<script>
  import In from "@/components/atoms/In";
  import Btn from "@/components/atoms/Btn";
  import Banner from "@/components/atoms/Banner";
  import SaveFile from "@/components/atoms/SaveFile";
  import Loading from "@/components/atoms/Loading";
  import CardsLoadingSpinner from "@/components/atoms/CardsLoadingSpinner";
  export default {
    components: { In, Btn, Banner, SaveFile, Loading, CardsLoadingSpinner },
    created(){
      this.$store.dispatch("saveFiles/loadSaveFiles", null, {root: true});
    },
    data(){
      return {
        new_project: false,
        new_project_name: '',
      }
    },
    computed: {
      saved(){
        return this.$store.get('saveFiles/saved');
      },
      existingSavedFile(){
        return this.$store.get('saveFiles/saveFilesById', this.$store.get('saveFiles/activeSaveFileId') )
      },
      saveFiles(){
        // console.log(this.$store.get('saveFiles/saveFiles').length)
        return this.$store.get('saveFiles/saveFiles')
      }
    },
    watch: {
      saved(){
        if(this.saved){
          this.new_project = false;
          this.new_project_name = '';
        }
      }
    }
  }
</script>

<template>
  <Banner>
    <div id="save-page">
      <transition name="fade-loading">
        <div id="save-as-overlay" class="overlay" v-if="new_project">
          <div class="module saving" v-click-outside="() => new_project = false">
            <div class="create-project">
              <div class="create-project-title">
                Project Name
              </div>
              <in v-model="new_project_name" class="input" placeholder="My Awesome Project" :autofocus="true"></in>
              <btn type="fill" @click="$store.dispatch('saveFiles/triggerSaveNewProject', {name: new_project_name})">Save Project</btn>
            </div>
          </div>
        </div>
      </transition>
      <div class="save-module">
        <div class="save-title">
          Save As
        </div>
        <CardsLoadingSpinner v-if="$store.get('saveFiles/saveFilesLoading')"/>
        <div v-else class="save-container">
          <div class="new-project" @click="() => new_project = true">
            <div class="new-button">
              <div class="fa fa-save"></div>
              Save New Project
            </div>
          </div>
          <SaveFile v-for="saveFile in saveFiles" :key="saveFile.id" :save-file="saveFile" :show-options="$store.get('vr')" :selected="$store.get('saveFiles/activeSaveFileId') == saveFile.id" :save="true" @click="$store.dispatch('saveFiles/triggerSaveExistingProject', {id: saveFile.id, name: saveFile.name})"/>
        </div>
      </div>
    </div>
  </Banner>
</template>

<style lang="scss" scopeds>
@import "~@/styles/constants";
#save-page{
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  #save-as-overlay{
    z-index: 8 !important;
  }
}
</style>